import React from "react";
import { motion } from "framer-motion";
import { Target } from "@phosphor-icons/react";

const negatives = [
  "Keine überladene Agrarsoftware.",
  "Keine Schulungen nötig.",
  "Keine komplizierten Menüs.",
];

export const TrustSection = () => {
  return (
    <section
      id="vertrauen"
      data-testid="trust-section"
      className="relative py-24 sm:py-32"
    >
      <div className="absolute inset-0 bg-topo opacity-30 pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
            Vertrauen
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-forest-900 tracking-tight max-w-3xl">
            Was Sie bei Plantus <span className="text-forest-600">nicht</span> finden.
          </h2>

          <ul className="mt-12 space-y-4">
            {negatives.map((line, i) => (
              <motion.li
                key={line}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
                data-testid={`trust-neg-${i}`}
                className="flex items-baseline gap-4 font-heading text-xl sm:text-2xl lg:text-3xl text-[#7A827C]"
              >
                <span className="text-terracotta font-bold leading-none">×</span>
                <span className="line-through decoration-2 decoration-terracotta/50 underline-offset-2">
                  {line}
                </span>
              </motion.li>
            ))}
          </ul>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
            className="mt-14 relative rounded-3xl bg-forest-700 text-white px-7 sm:px-12 py-10 sm:py-12 overflow-hidden"
          >
            <div
              className="absolute inset-0 opacity-15"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
                backgroundSize: "26px 26px",
              }}
            />
            <div className="relative flex items-start gap-5 max-w-3xl">
              <div className="w-12 h-12 rounded-2xl bg-terracotta/20 border border-terracotta/40 flex items-center justify-center flex-shrink-0">
                <Target size={24} weight="duotone" className="text-terracotta" />
              </div>
              <div>
                <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-terracotta mb-2">
                  Unser Versprechen
                </div>
                <p className="font-heading text-xl sm:text-2xl lg:text-3xl leading-snug">
                  Eine Anwendung mit einem klaren Ziel:{" "}
                  <span className="text-terracotta">
                    Pflanzenschutz-Dokumentation
                  </span>{" "}
                  so einfach wie möglich machen.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
